<template>
  <div class="dev-choose-box">
    <span class="dev-choose-tit">{{ $t('message["549"]') }}：</span>
    <a-cascader
      :options="currentDevelopDatas"
      change-on-select
      class="dev-choose-list"
      :placeholder="developPlace"
      @change="onChange"
    />
    <span class="dev-choose-tit">{{ $t('message["1370"]') }}：</span>
    <a-select
      :placeholder="infoFromTit"
      class="select-choose-list"
      @change="handleChange"
    >
      <a-select-option
        v-for="(item) in orginDatas"
        :key="item.fieldkey"
        :value="item.fieldkey"
      >
        {{ item.fieldname }}
      </a-select-option>
    </a-select>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      args: {}
    }
  },
  computed: {
    ...mapState('config/relation', ['orginDatas']),
    ...mapGetters('config/relation', ['currentDevelopDatas']),
    developPlace () {
      return this.$t('message["871"]')
    },
    infoFromTit () {
      return this.$t('message["1370"]')
    }
  },
  methods: {
    ...mapActions('config/relation', ['fetchRelationDatas']),
    async onChange (value, n) {
      let obj = {}
      let newObj = {}
      if (value.length) {
        n.forEach((item) => {
          const key = item.keyname
          newObj[key] = item.id
          obj = Object.assign(obj, newObj)
        })
      }
      const chain = await this.fetchRelationDatas()
      chain.params(obj)
        .fetch()
      this.args = obj
    },
    async handleChange (val) {
      const chain = await this.fetchRelationDatas()
      const objNew = Object.assign(this.args, { fieldkey: val })
      chain.params(objNew)
        .fetch()
    }
  }
}
</script>
<style lang="scss" scoped>
.dev-choose-box {
  margin-bottom: 24px;
  .dev-choose-tit {
    color:#666;
    margin-right: 4px;
  }
  .dev-choose-list {
    width: 320px;
    margin-right: 32px;
  }
  .select-choose-list {
    width:320px;
  }
}
</style>
